import {
    useMemo,
} from 'react'
import FormWithControls from 'app/shared-components/FormWithControls'
import StatusHandler from 'app/shared-components/StatusHandler'
import useFieldsWithClassName from 'app/hooks/useFieldsWithClassName'
import LoggerRequest from 'app/requests/Logger.requests'
import {
    generateSkyNetLink,
} from 'app/SkyNetRoutes'
import useContainerManagementRoutes from 'app/SkyNetRoutes/hooks/useContainerManagementRoutes'

import {
    WithId,
} from 'app/types/common.types'
import useGetLoggerByLoggerNumber from '../hooks/useGetLoggerByLoggerNumber'
import useStyles from './LoggerUpdate.style'
import getLoggerUpdateFields from './LoggerUpdate.fields'

const LoggerUpdate = ({
    id: loggerNumber,
}: Readonly<WithId<string>>) => {
    const {
        classes,
    } = useStyles()
    const {
        Containers: ContainersRoutes,
    } = useContainerManagementRoutes()

    const {
        data,
        isDataReady,
        isFetching,
        isError,
        error,
        invalidate,
    } = useGetLoggerByLoggerNumber(loggerNumber)

    const fields = useMemo(() => {
        return getLoggerUpdateFields({
            rentingCompany: data?.rentingCompany,
            containerSerialNumber: data?.containerSerialNumber,
            containerLink: data?.containerSerialNumber ? generateSkyNetLink({
                domainPath: ContainersRoutes.Overview.path,
                params: {
                    key: data?.containerSerialNumber,
                },
            }) : null,
        })
    }, [
        ContainersRoutes.Overview.path,
        data?.containerSerialNumber,
        data?.rentingCompany,
    ])

    const fieldsWithClasses = useFieldsWithClassName(fields, classes)

    return (
        <StatusHandler
            isSuccess={isDataReady}
            isFetching={isFetching}
            isError={isError}
            error={error}
        >
            <FormWithControls
                name={LoggerRequest.domainName}
                value={data}
                fields={fieldsWithClasses}
                onSuccess={invalidate}
                classNames={{
                    gridWrapper: classes.gridWrapper,
                }}
                requestParams={LoggerRequest.update({
                    serialNumber: String(data?.id),
                })}
                exists
            />
        </StatusHandler>
    )
}

export default LoggerUpdate
